"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const BotaoFechar_1 = __importDefault(require("./BotaoFechar"));
const Modal = ({ open, onClose, children, fullScreen = false, }) => {
    return (react_1.default.createElement(core_1.Dialog, { open: open, onClose: onClose, fullScreen: fullScreen },
        onClose && (react_1.default.createElement(core_1.DialogTitle, null,
            react_1.default.createElement(BotaoFechar_1.default, { onClose: onClose }))),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.Card, null,
                react_1.default.createElement(core_1.CardContent, null, children)))));
};
exports.Modal = Modal;
//# sourceMappingURL=index.js.map